/* eslint-disable import/prefer-default-export */
export const getResource = (store, uid) => store.resource[uid]
